import { processVariable, buildWhatsAppProcessedParams } from '@chatwoot/utils';

// Constants and pure template helpers are shared with the mobile app via
// @chatwoot/utils so the logic lives in one place.
export {
  MEDIA_FORMATS,
  COMPONENT_TYPES,
  findComponentByType,
  processVariable,
} from '@chatwoot/utils';

export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_CATEGORY = 'UTILITY';

export const allKeysRequired = value => {
  const keys = Object.keys(value);
  return keys.every(key => value[key]);
};

// Canonical list of NAMED template variables that the backend resolves
// automatically when sent blank. MUST mirror
// Whatsapp::NamedTemplateVarsResolver::STATIC_VAR_MAP keys (Ruby). If you add a
// var there, add it here too.
export const AUTO_RESOLVABLE_NAMED_VARS = [
  'contact_name',
  'contact_first_name',
  'contact_last_name',
  'contact_email',
  'contact_phone',
  'contact_id',
  'conversation_id',
  'inbox_id',
  'inbox_name',
  'agent_name',
  'agent_first_name',
  'agent_last_name',
  'agent_email',
];

// Backend also resolves custom attributes via these prefixes
// (contact_custom_<key> / conversation_custom_<key>).
const AUTO_RESOLVABLE_PREFIXES = ['contact_custom_', 'conversation_custom_'];

// True when a NAMED variable is auto-filled server-side, so the agent may
// leave it blank in the send form.
export const isAutoResolvableNamedVar = key =>
  AUTO_RESOLVABLE_NAMED_VARS.includes(key) ||
  AUTO_RESOLVABLE_PREFIXES.some(prefix => String(key).startsWith(prefix));

// Validates that every REQUIRED body param has a value. For NAMED templates,
// auto-resolvable variables may be left blank (the backend fills them via
// Whatsapp::NamedTemplateVarsResolver). For positional templates every value
// is required.
export const requiredBodyKeysFilled = (body, isNamed = false) => {
  if (!body) return true;
  return Object.keys(body).every(key => {
    if (isNamed && isAutoResolvableNamedVar(key)) return true;
    return Boolean(body[key]);
  });
};

export const replaceTemplateVariables = (templateText, processedParams) => {
  return templateText.replace(/{{([^}]+)}}/g, (match, variable) => {
    const variableKey = processVariable(variable);
    return processedParams.body?.[variableKey] || `{{${variable}}}`;
  });
};

// The media-header flag is derived from the template inside the shared helper;
// the second argument is kept for backwards-compatible call sites.
export const buildTemplateParameters = template =>
  buildWhatsAppProcessedParams(template);
